/* 30/09 perf fiche : sur la fiche produit, démarre juste APRÈS le 1er affichage (#almea-pdp-pret) — élément caché, prêt quelques ms après. */
/* 30/09 perf : ce fichier est chargé en « async » (il ne bloque plus l'affichage de la page).
   Il attend son repère #almk-cartskin (posé juste avant la balise script) pour démarrer exactement au même moment qu'avant.
   Sans repère sur la page : il démarre à la fin du chargement. */
(function almBoot(){
  if (document.readyState === 'loading' && (!document.getElementById('almk-cartskin') || (document.getElementById('almea-render-barrier') && !document.getElementById('almea-pdp-pret')))) { setTimeout(almBoot, 20); return; }

(function () {
  'use strict';
  if (window.__ntycInit) return;
  window.__ntycInit = true;

  var COLORS = {
    'rose': '#e8a0b8', 'turquoise': '#3fbfc0', 'bleu': '#2a5fb8', 'bleu ciel': '#9cc9ee',
    'bleu nuit': '#1c2e4a', 'vert': '#5d8a53', 'violet': '#8a68c8', 'gris': '#9aa3a8',
    'sombre': '#57422e', 'clair': '#d8c49a', 'lilas': '#c5a8e0', 'orange': '#ef7d2a',
    'jaune': '#eecf4a', 'rouge': '#c94437', 'noir': '#111111', 'blanc': '#f4f4f4',
    'beige': '#e3d5b8', 'marron': '#6b4a2f'
  };

  var RX_MONTHLY = /d[eè]s\s*\d[\d\s.,]*\s*€\s*\/\s*m(ois)?/i;
  var SHIP_WANT = 'Kostenlos';

  /* 18/09/2026 : « pret » = le tiroir #mzc-drawer est dans la page (rendu juste apres le header), plus la fin de la
     lecture de toute la page. Ce script est execute dans le header (avant le tiroir) : on guette son arrivee avec un
     observateur coupe des qu'il est la ; filet DOMContentLoaded. */
  function ready(fn) {
    if (document.getElementById('mzc-drawer') || document.readyState !== 'loading') { fn(); return; }
    var fait = false, mo = null;
    function go() { if (fait) return; fait = true; try { if (mo) mo.disconnect(); } catch (e) {} fn(); }
    try {
      mo = new MutationObserver(function () { if (document.getElementById('mzc-drawer')) go(); });
      mo.observe(document.documentElement, { childList: true, subtree: true });
    } catch (e) {}
    document.addEventListener('DOMContentLoaded', go);
  }

  /* ── Code promo (footer, repliable) ── RÉÉCRIT LE 01/09
     AVANT : le code était simplement rangé en sessionStorage et le panneau affichait
     « appliqué » quoi qu'il arrive, même pour un code qui n'existe pas, sans aucun moyen
     de le retirer. MAINTENANT, comme sur Nautiya : on passe par Shopify
     (/discount/CODE puis /cart/update.js), on relit le panier, et on n'annonce
     « appliqué » QUE si Shopify l'a vraiment retenu. Et on peut le retirer. */
  var ntycPromoActif = '';
  var ntycPromoMontant = 0;
  var ntycPromoPct = 0;       /* 10/10 : code en pourcentage -> on affiche « −10 % » (Lancelot) */   /* 16/09 : montant de la remise de commande, en centimes */
  var ntycSousTotal = 0;      /* 16/09 : sous-total des lignes avant remise de commande */
  var ntycTotal = 0;          /* 16/09 : total du panier, en centimes (pour la mensualite) */

  function promoCode() { return ntycPromoActif; }

  /* Le code saisi par le client est memorise a part. Impossible de le deduire du panier :
     dans /cart.js, Shopify renvoie un `type` VIDE pour les applications de remise, donc on ne
     peut pas distinguer un code saisi d une remise automatique (Pack de 2, Pack de 3).
     On verifie donc qu une remise porte exactement le titre du code saisi. */
  function promoCodeSaisi() {
    try { return sessionStorage.getItem('ntycPromo') || ''; } catch (e) { return ''; }
  }
  function promoCodeSaisiSet(v) {
    try { if (v) sessionStorage.setItem('ntycPromo', v); else sessionStorage.removeItem('ntycPromo'); } catch (e) {}
  }

  /* 01/09 (2e version) - ON LIT LE PANIER, PAS LA MEMOIRE DU NAVIGATEUR.
     Avant : on n affichait un code que s il etait dans sessionStorage. Si cette memoire
     etait vide (nouvel onglet, navigation privee, cache vide) alors que la remise courait
     toujours cote Shopify, le panneau affichait « Ajouter un code promo » pendant que le
     bouton Commander restait a 226,80 € au lieu de 251,99 €. L ecran mentait.

     Maintenant : la seule source de verite est le panier. Depuis le 01/09 les packs sont
     des remises PRODUIT (allouees aux lignes) et le code une remise COMMANDE. Donc toute
     application presente dans `cart_level_discount_applications` est forcement un code
     saisi : c est notre discriminant, fiable et sans memoire locale. */
  function promoLireLePanier(apres) {
    /* 26/10 : lecture partagée avec le tiroir (window.almLirePanier, assets/z-paniermasazen.js) */
    (window.almLirePanier ? window.almLirePanier() : fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }))
      .then(function (c) {
        var niveauPanier = c.cart_level_discount_applications || [];
        var titre = '';
        var montant = 0;
        for (var i = 0; i < niveauPanier.length; i++) {
          if (niveauPanier[i] && niveauPanier[i].title) {
            if (!titre) { titre = niveauPanier[i].title; ntycPromoPct = (niveauPanier[i].value_type === 'percentage') ? parseFloat(niveauPanier[i].value) || 0 : 0; }
            montant += (niveauPanier[i].total_allocated_amount || 0);
          }
        }
        ntycPromoActif = titre;
        ntycPromoMontant = montant;
        ntycTotal = c.total_price || 0;
        ntycSousTotal = (c.items_subtotal_price != null) ? c.items_subtotal_price : (ntycTotal + montant);
        promoCodeSaisiSet(titre);
        if (apres) apres(ntycPromoActif);
      })
      .catch(function () { if (apres) apres(ntycPromoActif); });
  }

  /* 01/09 - GARDE ANTI-BOUCLE, indispensable.
     promoLinkSync() est rappele par enhance(), lui-meme declenche par un MutationObserver.
     Si on reecrit le DOM a chaque passage, l ecriture provoque une mutation, qui rappelle
     enhance(), qui reecrit... la page se fige. On n ecrit QUE si l etat change vraiment. */
  function promoMsgOk(msg, code) {
    if (msg.dataset.ntycCode === code) return;
    msg.dataset.ntycCode = code;
    msg.className = 'ntyc-promo-msg';
    msg.textContent = '';
  }
  function promoMsgErr(msg, texte) {
    msg.dataset.ntycCode = '';
    msg.className = 'ntyc-promo-msg on err';
    msg.textContent = texte;
  }

  /* Le LIEN porte tout l etat, comme sur Nautiya :
     sans code  -> « Ajouter un code promo »
     avec code  -> « Code « X » appliqué · modifier »  + un bouton « Retirer » a cote. */
  function promoLinkSync() {
    var l = document.getElementById('ntyc-promo-link');
    if (!l) return;
    var wrap = document.getElementById('ntyc-promo');
    var c = promoCode();
    var etat = (c || '') + '|' + ntycPromoMontant + '|' + ntycTotal;
    if (wrap && wrap.dataset.ntycEtat === etat) return;
    if (wrap) wrap.dataset.ntycEtat = etat;

    var rm = document.getElementById('ntyc-promo-remove');
    if (c) {
      /* 16/09, regle de Lancelot : on affiche « -10 % » tant que l economie fait moins de
         10 €, et le montant en euros au-dela (« -12,50 € »). */
      var eco = '';
      /* 10/10 (Lancelot) : un code en % s affiche en % (« −10 % »), un code en euros en euros. */
      if (ntycPromoPct > 0) { eco = '−' + (Math.round(ntycPromoPct * 10) / 10).toString().replace('.', ',') + ' %'; }
      else if (ntycPromoMontant >= 1000) { eco = '−' + euros(ntycPromoMontant); }
      else if (ntycPromoMontant > 0 && ntycSousTotal > 0) { eco = '−' + Math.round(ntycPromoMontant / ntycSousTotal * 100) + ' %'; }
      l.textContent = 'Code ' + c + ' angewendet' + (eco ? ' · ' + eco : '');
      l.classList.add('has');
      if (!rm && wrap) {
        rm = document.createElement('button');
        rm.type = 'button';
        rm.id = 'ntyc-promo-remove';
        rm.className = 'ntyc-promo-retirer';
        rm.textContent = 'Entfernen'; /* 26/10 : était en français */
        l.insertAdjacentElement('afterend', rm);
      }
    } else {
      l.textContent = 'Rabattcode hinzufügen';
      l.classList.remove('has');
      if (rm) rm.remove();
    }

    klarnaSync();
    var msg = document.getElementById('ntyc-promo-msg');
    if (msg && !msg.classList.contains('err') && msg.dataset.ntycCode !== etat) {
      msg.dataset.ntycCode = etat;
      msg.className = 'ntyc-promo-msg';
      msg.textContent = '';
    }
  }

  function euros(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }
  /* 16/09 : ligne « X fois sans frais avec Klarna : Y € / mois », texte et nombre de
     mensualites regles dans la section (div#ntyc-config), montant calcule sur le total. */
  function klarnaSync() {
    var cfg = document.getElementById('ntyc-config');
    var promo = document.getElementById('ntyc-promo');
    if (!cfg || !promo) return;
    var texte = cfg.getAttribute('data-klarna-texte') || '';
    var nb = parseInt(cfg.getAttribute('data-klarna-nb'), 10) || 3;
    var k = document.getElementById('ntyc-klarna');
    /* 17/09 : le montant suit le TOTAL AFFICHE dans le pied (il change a chaque +/-),
       pas seulement la derniere lecture de /cart.js (qui ne bougeait pas). */
    var total = ntycTotal;
    var amtEl = document.querySelector('#mzc-footer .mzc-footer-subtotal-amount');
    if (amtEl) {
      var m = (amtEl.textContent || '').replace(/\s/g, '').match(/(\d+)[,.](\d{2})/);
      if (m) total = parseInt(m[1], 10) * 100 + parseInt(m[2], 10);
    }
    if (!texte || !total) { if (k) k.remove(); return; }
    /* 17/09 : toutes les mensualites possibles, de 3 jusqu au max regle : « 3 × 37,80 € ou 4 × 28,35 € sans frais » */
    var parts = [];
    for (var n = Math.min(3, nb); n <= nb; n++) parts.push('<b>' + n + ' × ' + euros(Math.ceil(total / n)) + '</b>');
    /* 17/09, maquette A : « ou 3 × 24,00 € sans frais avec Klarna » (le texte du reglage sert d interrupteur) */
    var logoTpl = document.getElementById('ntyc-klarna-logo-tpl');
    var logo = logoTpl ? logoTpl.innerHTML.trim() : '';
    /* logo Klarna A GAUCHE, dans la colonne de l etiquette du code promo (demande du 17/09) */
    /* 05/10 (Lancelot) : plus de montants « 3 × … ou 4 × … », juste « Paiement en 4× sans frais avec Klarna ou PayPal ». */
    /* 03/11 (Lancelot, maquette A) : logo PayPal et logo Klarna côte à côte (sans « ou », Lancelot 01h47) + « · 4 × <total/4> sans frais » (montant recalculé à chaque changement du panier ;
       logos officiels Shopify payment_type_svg_tag, modèles posés par snippets/nautiya-cart-skin et sections/z-paniermasazen).
       DE / UK : pas de « 4 × » tant que l'offre 4 fois n'est pas vérifiée dans ces pays (texte général gardé).
       RETOUR : var html = (logo || '<b>Klarna</b>') + '<span><b>In Raten zahlen</b> mit Klarna oder PayPal</span>'; */
    var ppTpl = document.getElementById('almcz-paypal-tpl');
    var pp = ppTpl ? ppTpl.innerHTML.trim() : '<b>PayPal</b>';
    var html = '<span class="almcz-pay__l">' + pp + (logo || '<b>Klarna</b>') + '</span>' + '<span class="almcz-pay__m">· In Raten zahlen</span>';
    if (!k) {
      k = document.createElement('div');
      k.className = 'ntyc-klarna';
      k.id = 'ntyc-klarna';
    }
    if (k.previousElementSibling !== promo) promo.insertAdjacentElement('afterend', k);
    if (k.dataset.ntycHtml !== html) { k.dataset.ntycHtml = html; k.innerHTML = html; }
  }

  function promoRafraichir() {
    try { if (window.MzCartV2 && MzCartV2.fetch) MzCartV2.fetch(); } catch (e) {}
    promoLireLePanier(function () { promoLinkSync(); });
  }

  document.addEventListener('click', function (e) {
    var l = e.target.closest('#ntyc-promo-link');
    if (!l) return;
    e.preventDefault();
    var box = document.getElementById('ntyc-promo-box');
    if (!box) return;
    var ouvert = !box.classList.contains('open');
    box.classList.toggle('open', ouvert);
    l.setAttribute('aria-expanded', ouvert ? 'true' : 'false');
    if (ouvert) {
      var m = document.getElementById('ntyc-promo-msg');
      if (m && m.classList.contains('err')) { m.className = 'ntyc-promo-msg'; m.textContent = ''; m.dataset.ntycCode = ''; }
      var i = document.getElementById('ntyc-promo-input');
      if (i) setTimeout(function () { i.focus(); i.select(); }, 250);
    }
  });

  document.addEventListener('click', function (e) {
    if (e.target.closest('#ntyc-promo-remove')) {
      e.preventDefault();
      var m = document.getElementById('ntyc-promo-msg');
      if (m) { m.className = 'ntyc-promo-msg on'; m.textContent = 'Wird entfernt…'; /* 26/10 : était en français */ }
      if (window.almPanierEcrit) window.almPanierEcrit(); /* 26/10 : écriture du panier → la prochaine lecture repart à zéro */
      fetch('/discount/NTYC_AUCUN_CODE_XYZ', { method: 'GET', redirect: 'manual', credentials: 'same-origin' } /* 17/09 perf : le cookie est pose par la redirection, inutile de telecharger la page (183 Ko) */)
        .then(function () {
          if (window.almPanierEcrit) window.almPanierEcrit(); /* 26/10 : écriture du panier → la prochaine lecture repart à zéro */
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ discount: '' })
          });
        })
        .then(function () {
          try { localStorage.setItem('nautiya_promo_retire', ntycPromoActif || codeMemorise() || localStorage.getItem('nautiya_promo') || ''); sessionStorage.removeItem('ntycPromo'); } catch (err) {}
          ntycPromoActif = '';
          promoCodeSaisiSet('');
          var i = document.getElementById('ntyc-promo-input');
          if (i) i.value = '';
          if (m) { m.className = 'ntyc-promo-msg'; m.textContent = ''; }
          promoRafraichir();
        })
        .catch(function () { if (m) promoMsgErr(m, 'Entfernen fehlgeschlagen, bitte erneut versuchen.'); });
      return;
    }

    var ap = e.target.closest('#ntyc-promo-apply');
    if (!ap) return;
    e.preventDefault();
    var input = document.getElementById('ntyc-promo-input');
    var msg = document.getElementById('ntyc-promo-msg');
    if (!input || !msg) return;
    var code = (input.value || '').trim();
    if (!code) { promoMsgErr(msg, 'Geben Sie einen Rabattcode ein.'); return; }
    try { localStorage.removeItem('nautiya_promo_retire'); } catch (err) {}
    ap.disabled = true;
    var libelle = ap.textContent;
    ap.textContent = '…';
    msg.className = 'ntyc-promo-msg'; msg.textContent = ''; msg.dataset.ntycCode = '';
    if (window.almPanierEcrit) window.almPanierEcrit(); /* 26/10 : écriture du panier → la prochaine lecture repart à zéro */
    fetch('/discount/' + encodeURIComponent(code), { method: 'GET', redirect: 'manual', credentials: 'same-origin' } /* 17/09 perf : le cookie est pose par la redirection, inutile de telecharger la page (183 Ko) */)
      .then(function () {
        if (window.almPanierEcrit) window.almPanierEcrit(); /* 26/10 : écriture du panier → la prochaine lecture repart à zéro */
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: code })
        });
      })
      .then(function () {
        /* On memorise le code AVANT la verification : promoLireLePanier compare les
           remises du panier au code saisi, il lui faut donc deja cette valeur.
           Si la verification echoue, promoLireLePanier l efface tout seul. */
        promoLireLePanier(function (actif) {
          ap.disabled = false; ap.textContent = libelle;
          if (actif && actif.toUpperCase() === code.toUpperCase()) {
            /* 10/10 14h50 : le code tapé par le client devient LE code mémorisé (avant, un ancien code — roue, pop-up — revenait l'écraser à l'ajout suivant) */
            try { localStorage.setItem('nautiya_promo', code); } catch (err) {}
            /* le panneau se referme tout seul, comme sur Nautiya */
            var box = document.getElementById('ntyc-promo-box');
            if (box) { box.classList.remove('open'); }
            var lien = document.getElementById('ntyc-promo-link');
            if (lien) lien.setAttribute('aria-expanded', 'false');
            msg.className = 'ntyc-promo-msg'; msg.textContent = ''; msg.dataset.ntycCode = actif;
            promoRafraichir();
          } else {
            /* Demande de Lancelot : le panneau se referme aussi quand le code est refuse.
               Le message est rendu HORS du panneau, il reste donc visible une fois replie. */
            var boxKo = document.getElementById('ntyc-promo-box');
            if (boxKo) boxKo.classList.remove('open');
            var lienKo = document.getElementById('ntyc-promo-link');
            if (lienKo) lienKo.setAttribute('aria-expanded', 'false');
            promoCodeSaisiSet('');
            promoMsgErr(msg, 'Dieser Code konnte nicht angewendet werden. Möglicherweise ist er abgelaufen oder nicht mit dem aktuellen Rabatt in Ihrem Warenkorb kombinierbar.');
          }
        });
      })
      .catch(function () {
        ap.disabled = false; ap.textContent = libelle;
        promoMsgErr(msg, 'Ein Fehler ist aufgetreten, bitte erneut versuchen.');
      });
  });

  /* 17/09 (idee de Lancelot) : « Nous ecrire » DEPLIE les moyens de contact DANS le panier
     (WhatsApp + e-mail, copies des liens de la bulle d aide), sans fermer le tiroir. */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('#ntyc-aide');
    if (!a) return;
    var panneau = document.getElementById('almaidePanneau');
    if (!panneau) return; /* pas de bulle sur cette page : le lien navigue vers /pages/contact */
    e.preventDefault();
    e.stopPropagation();
    var pan = document.getElementById('ntyc-aide-pan');
    if (!pan) {
      pan = document.createElement('div');
      pan.id = 'ntyc-aide-pan';
      pan.className = 'ntyc-aide-pan';
      var inner = document.createElement('div');
      inner.className = 'ntyc-aide-pan-in';
      panneau.querySelectorAll('.almaide__lien').forEach(function (l) { inner.appendChild(l.cloneNode(true)); });
      pan.appendChild(inner);
      a.insertAdjacentElement('afterend', pan);
    }
    var ouvert = !pan.classList.contains('open');
    pan.style.maxHeight = ouvert ? (pan.firstChild.scrollHeight + 16 + 'px') : '0px';
    pan.classList.toggle('open', ouvert);
    a.classList.toggle('open', ouvert);
    a.setAttribute('aria-expanded', ouvert ? 'true' : 'false');
    var lien = a.querySelector('.ntyc-aide-lien');
    if (lien) lien.textContent = ouvert ? 'Schließen' : 'Schreiben Sie uns';
    if (ouvert) setTimeout(function () { try { pan.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); } catch (err) {} }, 300);
    setTimeout(function () { try { window.dispatchEvent(new Event('resize')); } catch (err) {} }, 340);
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target && e.target.id === 'ntyc-promo-input') {
      e.preventDefault();
      var b = document.getElementById('ntyc-promo-apply');
      if (b) b.click();
    }
  });

  /* 16/09/2026 - CODE DE BIENVENUE APPLIQUE TOUT SEUL.
     Constat : un client s inscrit dans la pop-up (code BIENVENUE10 range en
     localStorage['nautiya_promo']), ajoute au panier, commande... et le code n est
     jamais applique : le pont de la section ne tournait qu au chargement de la page
     (donc pas sur la page ou il vient de s inscrire) et ne posait qu un cookie, sans
     passer par /cart/update.js : le tiroir affichait le prix plein. Paniers perdus.
     Maintenant : une seule fonction, appelee (1) au chargement de chaque page,
     (2) par la pop-up des l inscription (window.almeaAppliquerCode), (3) avant le
     depart au paiement. Elle applique le code cote Shopify puis relit le panier :
     le tiroir montre « Code BIENVENUE10 applique » et le prix remise, sans mentir. */
  var autoPromoEnCours = false;
  /* 17/09 : si le client a RETIRE le code lui-meme, on ne le remet plus tout seul
     (Lancelot : « ca me le remet tout le temps, c est chiant »). Le retrait est memorise. */
  function codeMemorise() {
    try {
      var c = (localStorage.getItem('nautiya_promo') || '').trim();
      var r = (localStorage.getItem('nautiya_promo_retire') || '').trim();
      if (c && r && c.toUpperCase() === r.toUpperCase()) return '';
      return c;
    } catch (e) { return ''; }
  }
  function appliquerCode(code, apres) {
    if (!code || autoPromoEnCours) { if (apres) apres(ntycPromoActif); return; }
    autoPromoEnCours = true;
    if (window.almPanierEcrit) window.almPanierEcrit(); /* 26/10 : écriture du panier → la prochaine lecture repart à zéro */
    fetch('/discount/' + encodeURIComponent(code), { method: 'GET', redirect: 'manual', credentials: 'same-origin' } /* 17/09 perf : le cookie est pose par la redirection, inutile de telecharger la page (183 Ko) */)
      .then(function () {
        if (window.almPanierEcrit) window.almPanierEcrit(); /* 26/10 : écriture du panier → la prochaine lecture repart à zéro */
        return fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ discount: code })
        });
      })
      .then(function () { return new Promise(function (ok) { promoLireLePanier(ok); }); })
      .catch(function () {})
      .then(function () {
        autoPromoEnCours = false;
        promoLinkSync();
        try { if (window.MzCartV2 && MzCartV2.fetch) MzCartV2.fetch(); } catch (e) {}
        if (apres) apres(ntycPromoActif);
      });
  }
  /* 10/10 (Lancelot : « le mec il voit pas qu il a son code promo ») : un code pose par un lien
     /discount/X ou un cookie (pas en memoire locale) n etait jamais lu -> « Ajouter un code promo »
     alors que la remise courait. Maintenant on lit TOUJOURS le panier, et le tiroir nous passe le
     panier a chaque mise a jour (window.__almPromoDepuisPanier). */
  window.__almPromoDepuisPanier = function (c) {
    if (!c) return;
    var niveauPanier = c.cart_level_discount_applications || [];
    var titre = '', montant = 0;
    /* 10/10 14h55 (Lancelot : « je mets BIENVENUE10, j'ajoute un produit, ça m'enlève le code ») : le code restait bien appliqué
       chez Shopify, mais après « + » la réponse de Shopify donne la remise SANS son nom (title vide) : le tiroir croyait
       qu'il n'y avait plus de code et affichait « Ajouter un code promo ». On prend alors le nom dans discount_codes. */
    var avantTitre = ntycPromoActif, avantPct = ntycPromoPct;
    var codesOk = (c.discount_codes || []).filter(function (d) { return d && d.code && d.applicable !== false; });
    for (var i = 0; i < niveauPanier.length; i++) {
      if (niveauPanier[i] && !niveauPanier[i].title && niveauPanier[i].type !== 'automatic' && codesOk.length) niveauPanier[i].title = codesOk[0].code;
      if (niveauPanier[i] && niveauPanier[i].title) {
        if (!titre) { titre = niveauPanier[i].title; ntycPromoPct = (niveauPanier[i].value_type === 'percentage') ? parseFloat(niveauPanier[i].value) || 0 : 0; }
        montant += (niveauPanier[i].total_allocated_amount || 0);
      }
    }
    if (titre && avantTitre && titre.toUpperCase() === String(avantTitre).toUpperCase() && !ntycPromoPct) ntycPromoPct = avantPct;
    ntycPromoActif = titre;
    ntycPromoMontant = montant;
    ntycTotal = c.total_price || 0;
    ntycSousTotal = (c.items_subtotal_price != null) ? c.items_subtotal_price : (ntycTotal + montant);
    try { promoLinkSync(); } catch (e) {}
  };
  function autoPromoSiBesoin(apres) {
    var code = codeMemorise();
    if (!code) { promoLireLePanier(function () { promoLinkSync(); if (apres) apres(ntycPromoActif); }); return; }
    /* on relit le panier avant de decider : la memoire du script peut etre perimee
       (code retire ailleurs, panier vide puis rerempli, autre onglet) */
    promoLireLePanier(function (actif) {
      /* 10/10 14h50 (Lancelot : « BIENVENUE10, j'ajoute un produit, ça m'enlève le code ») : si un code est DÉJÀ actif dans le panier
         (n'importe lequel), on n'y touche plus. Avant, le code mémorisé (roue, pop-up) écrasait le code tapé par le client. */
      if (actif) { promoLinkSync(); if (apres) apres(actif); return; }
      appliquerCode(code, apres);
    });
  }
  window.almeaAppliquerCode = function (code) {
    if (code) { try { localStorage.setItem('nautiya_promo', code); } catch (e) {} }
    autoPromoSiBesoin();
  };

  ready(function () { autoPromoSiBesoin(function () { promoLinkSync(); }); });

  /* Le bouton Commander part avec le code dans l adresse : si le cookie a ete perdu
     (navigation privee, cookie refuse), le paiement recoit quand meme le code. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('#mzc-drawer .mzc-checkout-btn');
    if (!btn) return;
    var code = ntycPromoActif || codeMemorise();
    if (!code) return;
    if (btn.tagName === 'A' && btn.getAttribute('href') && btn.getAttribute('href').indexOf('discount=') === -1) {
      btn.setAttribute('href', '/checkout?discount=' + encodeURIComponent(code));
    }
  }, true);

  /* ── Besoin d'aide : statut En ligne / Fermé (heure de Paris) ── */
  function parseHM(s) {
    var m = /^(\d{1,2}):(\d{2})$/.exec((s || '').trim());
    return m ? (parseInt(m[1], 10) * 60 + parseInt(m[2], 10)) : null;
  }
  function helpStatus(panel) {
    var days = (panel.getAttribute('data-days') || '').split(',').map(function (x) { return parseInt(x.trim(), 10); }).filter(function (x) { return x >= 1 && x <= 7; });
    var o = parseHM(panel.getAttribute('data-open'));
    var c = parseHM(panel.getAttribute('data-close'));
    var dot = panel.querySelector('.ntyc-help-dot');
    var st = panel.querySelector('.ntyc-help-state');
    if (!dot || !st) return;
    var online = false;
    try {
      var parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Paris', hour: '2-digit', minute: '2-digit', weekday: 'short', hour12: false }).formatToParts(new Date());
      var map = { Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6, Sun: 7 };
      var wd = 0, h = 0, mi = 0;
      parts.forEach(function (x) {
        if (x.type === 'weekday') wd = map[x.value] || 0;
        if (x.type === 'hour') h = parseInt(x.value, 10);
        if (x.type === 'minute') mi = parseInt(x.value, 10);
      });
      var mins = h * 60 + mi;
      if (o !== null && c !== null && days.length) {
        online = days.indexOf(wd) > -1 && mins >= o && mins < c;
      }
    } catch (e) {}
    dot.classList.toggle('on', online);
    st.textContent = online ? 'Online' : 'Derzeit geschlossen';
  }
  document.addEventListener('click', function (e) {
    var t = e.target.closest('#ntyc-help-toggle');
    var panel = document.getElementById('ntyc-help-panel');
    if (t && panel) {
      e.preventDefault();
      var open = !panel.classList.contains('open');
      panel.classList.toggle('open', open);
      t.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) helpStatus(panel);
      return;
    }
    if (panel && panel.classList.contains('open') && !e.target.closest('#ntyc-help-panel')) {
      panel.classList.remove('open');
      var tg = document.getElementById('ntyc-help-toggle');
      if (tg) tg.setAttribute('aria-expanded', 'false');
    }
  });

  document.addEventListener('click', function (e) {
    var rt = e.target.closest('#ntyc-ret-toggle');
    var rp = document.getElementById('ntyc-ret-panel');
    if (rt && rp) {
      e.preventDefault();
      var ro = !rp.classList.contains('open');
      rp.classList.toggle('open', ro);
      rt.setAttribute('aria-expanded', ro ? 'true' : 'false');
      return;
    }
    if (rp && rp.classList.contains('open') && !e.target.closest('#ntyc-ret-panel')) {
      rp.classList.remove('open');
      var rg = document.getElementById('ntyc-ret-toggle');
      if (rg) rg.setAttribute('aria-expanded', 'false');
    }
  });

  ready(function () {
    var drawer = document.getElementById('mzc-drawer');
    var body   = document.getElementById('mzc-body');
    var footer = document.getElementById('mzc-footer');
    var overlay = document.getElementById('mzc-overlay');
    if (!drawer || !body) return;

    var assetsEl = document.getElementById('ntyc-assets');
    var LOGO = assetsEl ? (assetsEl.getAttribute('data-logo') || '') : '';

    function syncOverlay() {
      if (!overlay) return;
      var on = drawer.classList.contains('active');
      if (overlay.classList.contains('active') !== on) overlay.classList.toggle('active', on);
      /* 02/11 23h30 (Lancelot : « l'animation n'est pas fluide ») : le flou plein écran se reposait ici à CHAQUE ouverture, aussi au téléphone (le CSS l'avait retiré sous 768 px) : il faisait saccader la glissade. Flou gardé seulement sur ordinateur. RETOUR : enlever la condition matchMedia. */
      if (on && window.matchMedia && matchMedia('(min-width: 768px)').matches) {
        overlay.style.webkitBackdropFilter = 'blur(10px)';
        overlay.style.backdropFilter = 'blur(10px)';
      }
    }
    new MutationObserver(syncOverlay).observe(drawer, { attributes: true, attributeFilter: ['class'] });
    syncOverlay();

    var header = drawer.querySelector('.mzc-header');
    var title  = drawer.querySelector('.mzc-title');
    var count  = document.getElementById('mzc-count');
    var closeBtn = drawer.querySelector('.mzc-close');
    if (closeBtn) {
      closeBtn.innerHTML = '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="#10222a" stroke-width="2" stroke-linecap="round"><path d="M18 6L6 18M6 6l12 12"/></svg>';
    }
    if (header && title) {
      if (count) header.appendChild(count);
      Array.prototype.slice.call(title.childNodes).forEach(function (n) {
        if (n.nodeType === 3) n.textContent = '';
      });
      if (!title.querySelector('.ntyc-title-text')) {
        var ts = document.createElement('span');
        ts.className = 'ntyc-title-text';
        ts.textContent = 'Ihr Warenkorb';
        title.appendChild(ts);
        /* 16/09, maquette B : « Votre panier · 1 ARTICLE » a la place de la pastille chiffree */
        var tc = document.createElement('span');
        tc.className = 'ntyc-title-count';
        title.appendChild(tc);
      }
    }
    function fmtCount() {
      if (!count) return;
      var t = count.textContent || '';
      var m = t.match(/\d+/);
      var v = m ? m[0] : '0';
      if (t !== v) count.textContent = v;
      var tc = title && title.querySelector('.ntyc-title-count');
      if (tc) {
        var n = parseInt(v, 10) || 0;
        var lib = n ? ('· ' + n + (n > 1 ? ' Artikel' : ' Artikel')) : '';
        if (tc.textContent !== lib) tc.textContent = lib;
      }
    }
    fmtCount();
    if (count) new MutationObserver(fmtCount).observe(count, { childList: true, characterData: true, subtree: true });

    var emptyTpl = document.getElementById('ntyc-empty-tpl');
    var xsellTpl = document.getElementById('ntyc-xsell-tpl');
    var infoTpl  = document.getElementById('ntyc-info-tpl');

    function cartHandles() {
      var hs = [];
      body.querySelectorAll('.mzc-item-name').forEach(function (a) {
        var href = a.getAttribute('href') || '';
        var m = href.match(/\/products\/([^\/?#]+)/);
        if (m) hs.push(m[1]);
      });
      return hs;
    }

    function cleanInstallments() {
      if (!footer) return;
      footer.querySelectorAll('.mzc-installment-option').forEach(function (o) {
        var t = (o.textContent || '').trim();
        var m = t.match(/(\d+)\s*[x×]/i);
        if (!m || m[1] === '10' || parseInt(m[1], 10) > 4) { o.remove(); return; }
        var want = m[1] + 'x';
        var hasExtra = t.replace(/\s/g, '') !== want;
        if (hasExtra) {
          Array.prototype.slice.call(o.childNodes).forEach(function (n) {
            if (n.nodeType === 3) n.textContent = '';
          });
          o.appendChild(document.createTextNode(want));
        }
      });
      footer.querySelectorAll('.mzc-installment-label').forEach(function (l) {
        var t = l.textContent || '';
        if (/300|€\s*\/\s*m|\/mois/i.test(t)) l.textContent = 'Ratenzahlung verfügbar';
      });
    }

    function cleanMonthly(root) {
      if (!root) return;
      root.querySelectorAll('.mzc-footer-shipping-badge, .mzc-summary-row span, .mzc-footer-shipping-label').forEach(function (el) {
        var t = el.textContent || '';
        if (RX_MONTHLY.test(t)) {
          var isLabel = el.className && el.className.indexOf('shipping-label') > -1;
          var want = isLabel ? 'Lieferung' : SHIP_WANT;
          if (el.textContent !== want) el.textContent = want;
        }
      });
    }

    /* 16/09, maquette B : le code promo vit SOUS LES ARTICLES (en haut), plus dans le pied.
       Le tiroir reconstruit son contenu a chaque mise a jour : on le repose a chaque passage. */
    /* 17/09, maquette A (bas du panier) : code promo + Klarna vivent dans le PIED, juste
       au-dessus du bouton Commander ; le milieu du tiroir respire. Etiquette au trait devant. */
    function promoEnsureFooter() {
      var btn = footer ? footer.querySelector('.mzc-checkout-btn') : null;
      var items = body.querySelector('.mzc-items');
      if (!btn && !items) return;
      var exist = document.getElementById('ntyc-promo');
      if (exist) {
        if (btn) {
          /* place voulue : promo, puis Klarna, puis le bouton */
          var kl = document.getElementById('ntyc-klarna');
          var ref = (kl && kl.nextElementSibling === btn) ? kl : btn;
          if (exist.nextElementSibling !== ref || exist.parentNode !== btn.parentNode) btn.parentNode.insertBefore(exist, ref);
        }
        else if (exist.previousElementSibling !== items) items.insertAdjacentElement('afterend', exist);
        return;
      }
      var w = document.createElement('div');
      w.className = 'ntyc-promo';
      w.id = 'ntyc-promo';
      w.innerHTML = '<span class="ntyc-promo-ico" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 12l-8 8-9-9V3h8z"/><circle cx="7.5" cy="7.5" r="1.3"/></svg></span>'
        + '<button type="button" class="ntyc-promo-link" id="ntyc-promo-link" aria-expanded="false" aria-controls="ntyc-promo-box">Rabattcode hinzufügen</button>'
        + '<div class="ntyc-promo-box" id="ntyc-promo-box">'
        + '<div class="ntyc-promo-row">'
        + '<input type="text" class="ntyc-promo-input" id="ntyc-promo-input" placeholder="Ihr Rabattcode" autocomplete="off" spellcheck="false">'
        + '<button type="button" class="ntyc-promo-btn" id="ntyc-promo-apply">Anwenden</button>'
        + '</div>'
        + '</div>'
        + '<p class="ntyc-promo-msg" id="ntyc-promo-msg"></p>';
      if (btn) btn.parentNode.insertBefore(w, btn); else items.insertAdjacentElement('afterend', w);
    }

    /* 16/09 : ordre de la maquette B — articles, code, Klarna, 90 nuits, frise de livraison, aide. */
    function ordonner() {
      var items = body.querySelector('.mzc-items');
      if (!items) return;
      /* preuve sociale en tete du contenu (order 0 en CSS) */
      var preuveTpl = document.getElementById('ntyc-preuve-tpl');
      /* 10/10 (Lancelot) : plus d avis dans le panier */
      var preuveVue = body.querySelector('#ntyc-preuve'); if (preuveVue) preuveVue.remove();
      /* 29/10 (Lancelot) : « Besoin d'aide ? » passe TOUT EN HAUT du panier (au-dessus de la barre livraison et des articles). */
      var suite = [document.getElementById('ntyc-nuits'), body.querySelector('.mzc-timeline')].filter(Boolean);
      var prev = items;
      suite.forEach(function (el) {
        if (el.previousElementSibling !== prev || el.parentNode !== items.parentNode) prev.insertAdjacentElement('afterend', el);
        prev = el;
      });
      var aide = document.getElementById('ntyc-aide'), aidePan = document.getElementById('ntyc-aide-pan'), haut = body.querySelector('.mzc-ship') || items;
      if (aide && haut.parentNode && aide.nextElementSibling !== (aidePan || haut)) haut.insertAdjacentElement('beforebegin', aide);
      if (aide && aidePan && aide.nextElementSibling !== aidePan) aide.insertAdjacentElement('afterend', aidePan);
      var info = document.getElementById('ntyc-info');
      if (info && !info.children.length) info.remove();
      caler();
    }

    /* 16/09 soir — LA PAGE DEFILAIT DERRIERE LE TIROIR (telephone). La couche
       almea-fix-scroll retire tout verrou de defilement (voulu : la page ne doit
       jamais se figer). Donc on ne verrouille rien : on rend le contenu du tiroir
       TOUJOURS defilable d au moins 2 px (cale en bas), et overscroll-behavior:contain
       (CSS du skin) empeche alors le geste de se propager a la page. */
    function caler() {
      var content = body.querySelector('.mzc-content');
      if (!content) return;
      var cale = document.getElementById('ntyc-cale');
      if (!cale) {
        cale = document.createElement('div');
        cale.id = 'ntyc-cale';
        cale.className = 'ntyc-cale';
        cale.setAttribute('aria-hidden', 'true');
      }
      if (cale.parentNode !== content) content.appendChild(cale);
      var h0 = cale.offsetHeight;
      cale.style.height = '0px';
      /* le contenu est une colonne flex qui ne remplit pas forcement la hauteur : on mesure
         ou finit le dernier vrai bloc, et la cale comble le vide + 4 px pour qu il y ait
         toujours quelque chose a faire defiler (sinon le geste part sur la page). */
      var cr = content.getBoundingClientRect(), kr = cale.getBoundingClientRect();
      var caleTop = kr.top - cr.top + content.scrollTop;
      var padBas = parseFloat(getComputedStyle(content).paddingBottom) || 0;
      var manque = content.clientHeight - caleTop - padBas + 4;
      var h = manque > 0 ? Math.round(manque) : 0;
      cale.style.height = h + 'px';
    }
    /* 17/09 — SWIPE FORT : la page derriere apparaissait. On ne fige toujours pas la page
       (couche fix-scroll), mais on bloque le geste a la source : hors du contenu defilant,
       ou au bout du contenu (haut/bas), le touchmove est annule → plus de chainage vers la page. */
    var touchY0 = 0, touchX0 = 0;
    drawer.addEventListener('touchstart', function (e) { if (e.touches && e.touches[0]) { touchY0 = e.touches[0].clientY; touchX0 = e.touches[0].clientX; } }, { passive: true });
    drawer.addEventListener('touchmove', function (e) {
      if (!drawer.classList.contains('active') || !e.touches || !e.touches[0]) return;
      /* 28/09 16h40 (Lancelot : « le slider du panier vide bug ») : un glissement HORIZONTAL dans un carrousel
         (best-sellers, suggestions) était annulé ici → le carrousel accrochait. On le laisse passer. 03/11 01h50 (Lancelot : « ça bug de ouf ») : idem pour les avis « Bien arrivé chez eux » (.almcz-rv__l). */
      var dx0 = e.touches[0].clientX - touchX0, dy0 = e.touches[0].clientY - touchY0;
      if (Math.abs(dx0) > Math.abs(dy0) && e.target && e.target.closest && e.target.closest('.mzc-best-rail, .almcz-rv__l, [class*="x-row"], [class*="caro"]')) return;
      var c = body.querySelector('.mzc-content');
      if (!c || !c.contains(e.target)) { if (e.cancelable) e.preventDefault(); return; }
      var dy = e.touches[0].clientY - touchY0;
      var enHaut = c.scrollTop <= 0, enBas = c.scrollTop + c.clientHeight >= c.scrollHeight - 1;
      if ((dy > 0 && enHaut) || (dy < 0 && enBas)) { if (e.cancelable) e.preventDefault(); }
    }, { passive: false });
    if (overlay) overlay.addEventListener('touchmove', function (e) { if (e.cancelable) e.preventDefault(); }, { passive: false });
    window.addEventListener('resize', function () { try { caler(); } catch (e) {} });
    /* le tiroir est masque a l ecriture : on recale a l ouverture, quand il a ses dimensions */
    new MutationObserver(function () { if (drawer.classList.contains('active')) { setTimeout(function () { try { caler(); } catch (e) {} }, 450); /* 02/11 23h30 : plus de recalage à 60 ms, en pleine glissade (saccade) */ } }).observe(drawer, { attributes: true, attributeFilter: ['class'] });

    function promoRestore() {
      var pi = document.getElementById('ntyc-promo-input');
      var pm = document.getElementById('ntyc-promo-msg');
      var pc = promoCode();
      if (pi && pm && pc && !pi.value && pm.dataset.ntycCode !== pc) {
        pi.value = pc;
        promoMsgOk(pm, pc);
      }
      promoLinkSync();
    }

    var AMP = document.getElementById('ntyc-ampoules');
    function listeAmp(k) { return AMP ? (AMP.getAttribute('data-' + k) || '').split(',').filter(Boolean) : []; }
    /* libelle, lot (photo + prix) par cas ; e27 et « trois » recoivent le meme lot de 3 E27 */
    var AMP_CAS = { e27: ['3er-Set LED-Leuchtmittel E27', 'e27'], trois: ['3er-Set LED-Leuchtmittel E27', 'e27'], e14: ['2er-Set LED-Leuchtmittel E14', 'e14'], g9: ['2er-Set LED-Leuchtmittel G9', 'g9'] };
    /* 17/09 (Lancelot) : dans le panier, montrer la PREMIERE photo de la fiche, pas l image de la
       variante (souvent une pastille de couleur ou une vue secondaire). Une requete /products/x.js
       par produit, gardee en memoire ; on ne touche a l image que si elle change. */
    var PHOTO_CACHE = {};
    function photoPrincipale(item) {
      var a = item.querySelector('a.mzc-item-img'), img = a && a.querySelector('img');
      if (!a || !img) return;
      var m = (a.getAttribute('href') || '').match(/\/products\/([a-z0-9-]+)/i);
      if (!m) return;
      var handle = m[1];
      function poser(src) {
        if (!src) return;
        var want = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=500';
        if (img.getAttribute('src') !== want) { img.setAttribute('src', want); img.removeAttribute('srcset'); }
      }
      if (PHOTO_CACHE[handle]) { poser(PHOTO_CACHE[handle]); return; }
      if (PHOTO_CACHE[handle] === '') return;
      PHOTO_CACHE[handle] = '';
      fetch('/products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (pr) {
        var src = (pr.images && pr.images[0]) || pr.featured_image || '';
        if (src && src.indexOf('//') === 0) src = 'https:' + src;
        PHOTO_CACHE[handle] = src;
        /* toutes les lignes de ce produit (le tiroir peut avoir ete re-rendu entre-temps) */
        body.querySelectorAll('a.mzc-item-img[href*="/products/' + handle + '"] img').forEach(function (im) {
          var want = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=500';
          if (im.getAttribute('src') !== want) { im.setAttribute('src', want); im.removeAttribute('srcset'); }
        });
      }).catch(function () { delete PHOTO_CACHE[handle]; });
    }

    function cadeauAmpoule(item) {
      if (!AMP || item.querySelector('.ntyc-cadeau')) return;
      var a = item.querySelector('a[href*="/products/"]');
      if (!a) return;
      var h = (a.getAttribute('href') || '').split('/products/')[1];
      if (!h) return;
      h = h.split('?')[0].split('#')[0].split('/')[0];
      var cas = '';
      ['e27', 'trois', 'e14', 'g9'].forEach(function (k) { if (!cas && listeAmp(k).indexOf(h) > -1) cas = k; });
      if (!cas) return;
      var lib = AMP_CAS[cas][0], lot = AMP_CAS[cas][1];
      var img = AMP.getAttribute('data-img-' + lot) || '';
      var prix = AMP.getAttribute('data-prix-' + lot) || '';
      var c = document.createElement('div');
      c.className = 'ntyc-cadeau';
      /* 17/09, maquette C : le cadeau est une VRAIE 2e ligne d article — photo du lot avec
         etiquette « Offert », nom, sous-titre, prix 0,00 € avec l ancien prix barre. */
      c.innerHTML = '<span class="ntyc-cadeau-img">' + (img ? '<img src="' + img + '" alt="" width="96" height="96" loading="lazy" decoding="async">' : '') + '<span class="ntyc-cadeau-tag">Kostenlos</span></span>'
        + '<span class="ntyc-cadeau-txt"><b class="ntyc-cadeau-nom">' + lib + '</b><span class="ntyc-cadeau-sub">Warmweiß · im Lieferumfang dieser Leuchte</span>'
        + '<span class="ntyc-cadeau-prix">0,00 €' + (prix ? ' <s>' + prix + '</s>' : '') + '</span></span>';
      item.appendChild(c);
    }

    function enhance() {
      var emptyNode = body.querySelector('.mzc-empty, .mzc-empty-top');
      if (emptyNode && emptyTpl && !body.querySelector('#ntyc-empty')) {
        var content = body.querySelector('.mzc-content') || body;
        /* 28/09 : on garde le carrousel des best-sellers (#mzc-best) sous le message « panier vide » */
        var almBest = body.querySelector('#mzc-best');
        content.innerHTML = '';
        content.appendChild(emptyTpl.content.cloneNode(true));
        var almVide = content.querySelector('#ntyc-empty');
        if (almBest && almVide) almVide.appendChild(almBest);
        /* 10/10 (Lancelot) : textes du panier vide plus sobres */
        var almTt = content.querySelector('.ntyc-empty-title'); if (almTt) almTt.textContent = 'Ihr Warenkorb ist leer';
        var almSs = content.querySelector('.ntyc-empty-sub'); if (almSs) almSs.textContent = 'Unsere Kunden beginnen oft mit einer dieser Leuchten.';
      }

      /* 17/09 : le tiroir est hors ecran a l ecriture, donc une image « lazy » n est
         chargee qu a l ouverture — le produit semblait ne pas s afficher. Chargement immediat. */
      /* 30/09 perf : au 1er rendu (page en cours de chargement), ces photos du tiroir (suggestions du panier vide) ne
         passent en immédiat qu'APRÈS le chargement de la page : elles ne volent plus la bande passante de la grande photo.
         Rendu du tiroir après chargement (ajout au panier…) : immédiat, comme avant. */
      (function (imgs) {
        function go() { imgs.forEach(function (im) { im.loading = 'eager'; }); }
        if (document.readyState === 'complete') go(); else window.addEventListener('load', function () { setTimeout(go, 800); });
      })(body.querySelectorAll('img[loading="lazy"]'));
      body.querySelectorAll('.mzc-item').forEach(function (item) { try { photoPrincipale(item); } catch (e) {} });
      body.querySelectorAll('.mzc-item:not([data-ntyc])').forEach(function (item) {
        item.setAttribute('data-ntyc', '1');
        var info = item.querySelector('.mzc-item-info');
        var name = item.querySelector('.mzc-item-name');
        /* 28/09 (Claude) : plus de logo/nom Nautiya dans les lignes du panier (image cachée mais téléchargée) */
        if (false && info && name && !info.querySelector('.ntyc-brand') && !info.querySelector('.ntyc-brand-logo')) {
          var b;
          if (LOGO) {
            b = document.createElement('img');
            b.className = 'ntyc-brand-logo'; b.loading = 'lazy'; b.decoding = 'async';
            b.src = LOGO;
            b.alt = 'Nautiya';
          } else {
            b = document.createElement('div');
            b.className = 'ntyc-brand';
            b.textContent = 'NAUTIYA';
          }
          info.insertBefore(b, name);
        }
        var v = item.querySelector('.mzc-item-variant');
        if (v && !v.querySelector('.ntyc-vline')) {
          var raw = (v.textContent || '').trim();
          if (raw) {
            v.innerHTML = '';
            raw.split(' / ').forEach(function (part) {
              part = part.trim();
              if (!part) return;
              /* 03/09 : le tiroir envoie desormais « Nom de l'option : Valeur ». On garde ce
                 libelle tel quel ; la pastille de couleur se cherche sur la VALEUR seule.
                 Le « Taille : » force n'est ajoute que si aucun libelle n'est fourni. */
              var sepIdx = part.indexOf(' : ');
              var valeur = sepIdx > -1 ? part.slice(sepIdx + 3) : part;
              var key = valeur.toLowerCase();
              var line = document.createElement('span');
              line.className = 'ntyc-vline';
              /* 16/09, maquette B : on n affiche que la VALEUR (« 30 cm · Noir »), sans « Taille : » */
              if (COLORS[key]) {
                var d = document.createElement('span');
                d.className = 'ntyc-dot';
                d.style.background = COLORS[key];
                line.appendChild(d);
              }
              line.appendChild(document.createTextNode(valeur));
              v.appendChild(line);
            });
          }
        }
        /* 17/09 : « Lot de 3 ampoules LED E27 offert » sous la ligne, memes listes que la fiche */
        cadeauAmpoule(item);
        var priceEl = item.querySelector('.mzc-item-price');
        if (priceEl && !priceEl.querySelector('.ntyc-off')) {
          var through = priceEl.querySelector('span[style*="line-through"]');
          if (through) {
            var nums = (priceEl.textContent || '').replace(/\s/g, '').match(/\d+(?:[.,]\d+)?/g);
            if (nums && nums.length >= 2) {
              var oldP = parseFloat(nums[0].replace(',', '.'));
              var newP = parseFloat(nums[1].replace(',', '.'));
              if (oldP > newP && oldP > 0) {
                var pct = Math.round((1 - newP / oldP) * 100);
                if (pct > 0 && pct < 100) {
                  var pill = document.createElement('span');
                  pill.className = 'ntyc-off';
                  pill.textContent = '-' + pct + '%';
                  priceEl.appendChild(pill);
                }
              }
            }
          }
        }
      });

      var items = body.querySelector('.mzc-items');
      if (items && xsellTpl && !body.querySelector('#ntyc-xsell')) {
        items.parentNode.insertBefore(xsellTpl.content.cloneNode(true), items.nextSibling);
        var wrap = body.querySelector('#ntyc-xsell');
        if (wrap) {
          var inCart = cartHandles();
          var shown = 0;
          Array.prototype.slice.call(wrap.querySelectorAll('.ntyc-x-card')).forEach(function (c) {
            var h = c.getAttribute('data-handle');
            if (inCart.indexOf(h) > -1 || shown >= 4) { c.remove(); }
            else { shown++; }
          });
          if (!shown) wrap.remove();
        }
      }

      if (items && infoTpl && !body.querySelector('#ntyc-info') && !body.querySelector('#ntyc-nuits')) {
        var contentEl = body.querySelector('.mzc-content');
        if (contentEl) contentEl.appendChild(infoTpl.content.cloneNode(true));
      }

      cleanMonthly(body);
      updateCheckout();
      ordonner();
    }

    function updateCheckout() {
      if (!footer) return;
      cleanInstallments();
      cleanMonthly(footer);
      var btn = footer.querySelector('.mzc-checkout-btn');
      if (!btn) return;
      promoEnsureFooter();
      promoRestore();
      klarnaSync(); /* le bloc promo peut n exister qu ici : la ligne Klarna se pose a ce moment-la */
      /* 03/11 01h (Lancelot : « PAIEMENT SÉCURISÉ COMMANDER » au téléphone) : le libellé du bouton n'est plus réécrit ici ; il est écrit une seule fois dans sections/z-paniermasazen (« Commander »). RETOUR : historique git du Brain avant le 03/11. */
      var pcode = promoCode();
      var wantHref = pcode ? ('/checkout?discount=' + encodeURIComponent(pcode)) : '/checkout';
      if (btn.getAttribute('href') !== wantHref) btn.setAttribute('href', wantHref);
      /* 16/09 : sous le bouton, les logos de paiement de la boutique (memes que la fiche)
         et « Paiement securise ». Plus de paragraphe legal ni de double mention du retour. */
      var payTpl = document.getElementById('ntyc-pay-tpl');
      if (payTpl && !footer.querySelector('#ntyc-pay')) {
        btn.parentNode.insertBefore(payTpl.content.cloneNode(true), btn.nextSibling);
      }
      klarnaSync();
    }

    new MutationObserver(function () { enhance(); }).observe(body, { childList: true, subtree: true });
    if (footer) new MutationObserver(function () { updateCheckout(); }).observe(footer, { childList: true, subtree: true, characterData: true });
    enhance();
    updateCheckout();
  });
})();

})();
